import { useEffect, useState } from 'react';
import axios from 'axios';
import { useSearchParams, useNavigate } from 'react-router-dom';

const BaseUrl = process.env.REACT_APP_BASE_URL;

export default function VerifyEmail() {
  const [searchParams] = useSearchParams();
  const [message, setMessage] = useState (null);
  const navigate = useNavigate();

  useEffect(() => {
    const token = searchParams.get('token');
    if (token) {
      axios.post(`${BaseUrl}vendor/verify_mail`, { token })
        .then(() => {
          setMessage('Email verified successfully!');
          setTimeout(() => {
            navigate('/dashboard');
          }, 1500); // 1.5s delay to show the message
        })
        .catch(() => setMessage('Verification failed or link is invalid.'));
    } else {
      setMessage('No verification token found.');
    }
  }, [searchParams, navigate]);

  return (
    <div className="max-w-md mx-auto mt-20 p-8 bg-white rounded-xl shadow text-center">
      <h2 className="text-2xl font-bold mb-4">Verify Email</h2>
      {message ? (
        <div className="text-lg">{message}</div>
      ) : (
        <div className="text-lg">Verifying...</div>
      )}
    </div>
  );
}
